import Vue from 'vue'
import App from './App.vue'
import router from './routes'
import store from './store'
import vuetify from './plugins/vuetify'
import './registerServiceWorker'
import env from './services/env'
import './models'
import Editor from '@tinymce/tinymce-vue'
import VueHead from 'vue-head'
import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete'

Vue.use(VueHead)
Vue.use(VuetifyGoogleAutocomplete, { apiKey: env.googleApiKey })
Vue.component('editor', Editor)
Vue.config.productionTip = false
store.dispatch('auth/init')

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
